import React from "react";

export default function FeatureBanner({ onOpenCategory }) {
  return (
    <div className="section">
      <div className="feature">
        <img
          src="https://images.unsplash.com/photo-1587314168485-3236d6710814?auto=format&fit=crop&w=800&q=80"
          alt="Empfehlung des Hauses"
        />
        <div className="feature-copy">
          <div className="eyebrow">EMPFEHLUNG</div>
          <h3>Fıstıklı Burma</h3>
          <p>Kusursuz fıstık lezzeti ve çıtır yufka deneyimi.</p>
          <button className="small-btn" onClick={onOpenCategory}>
            Jetzt Ansehen
          </button>
        </div>
      </div>
    </div>
  );
}
